import { generateFormValidations } from "../../../helpers/antdFormValidations";
import { GenerateInvoiceFormValues } from "./types";
import { getDiscountValidationError, InvoiceDiscountType } from "./discount";

const generateInvoiceValidations = generateFormValidations<GenerateInvoiceFormValues>(
  {
    invoiceType: [{ required: true, message: "Invoice type is required" }],
    paymentDetails: [
      { required: true, message: "Payment details are required" },
    ],
    invoiceDate: [{ required: true, message: "Invoice date is required" }],
    invoicePrefix: [
      { required: true, message: "Invoice number prefix is required" },
    ],
    indexNumber: [
      { required: true, message: "Invoice count number is required" },
    ],
    prefilledTitle: [
      { required: true, message: "Title is required" },
    ],
    title: [
      { required: true, message: "Title is required" },
    ],
    contractReference: [
      { required: true, message: "Contract reference is required" },
      {
        max: 100,
        message: "Contract reference must be less than 100 characters",
      },
    ],
    discountValue: [
      ({ getFieldValue }) => ({
        validator: (_rule, value: number | null | undefined): Promise<void> => {
          const discountType: InvoiceDiscountType | null | undefined = getFieldValue("discountType");
          const error = getDiscountValidationError(value, discountType);
          if (error) {
            return Promise.reject(new Error(error));
          }
          return Promise.resolve();
        },
      }),
    ],
  }
);

export default generateInvoiceValidations;
